import {
  faEdit,
  faEye,
  faEyeSlash,
  faFile,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { downloadExcel } from "react-export-table-to-excel";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddContact from "./addContact";
import AdditionalLead from "./additionalLead";
import "./app.css";
import Conf from "./conf";
import { secretKey } from "./data";
import LeadDetail from "./leadDetail";
import LeadSendDetail from "./leadSendDetails";
import Loading from "./loading.js";
import { attachCopyLogger } from "./logCopy";
import MultiSelect from "./multiSelect.js";
import ShowNote from "./showNote";

const MySwal = withReactContent(Swal2);
const API = "https://apiftpsplit.ftpeople.pl";
const hdrs = { "Content-Type": "application/json", Authorization: secretKey };
const PAGE_SIZES = [25, 50, 100, 200];

/* ─── debounce hook ─── */
function useDebounce(fn, delay) {
  const timer = useRef(null);
  return useCallback(
    (...args) => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => fn(...args), delay);
    },
    [fn, delay]
  );
}

const Database = (props) => {
  const isAdmin = props.user.role === "admin";

  /* ══════════ SERVER-SIDE PAGINATION STATE ══════════ */
  const [initLoading, setInitLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [clicks, setClicks] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);

  /* ── sorting (dual: primary statusPoz ASC, secondary date DESC) ── */
  const [sort, setSort] = useState("statusPoz");
  const [sortDir, setSortDir] = useState("ASC");
  const [sort2, setSort2] = useState("date");
  const [sortDir2, setSortDir2] = useState("DESC");

  /* ── filters ── */
  const [showFilters, setShowFilters] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");

  const [filterStatus, setFilterStatus] = useState([]);
  const [selectedOptionsStatus, setSelectedOptionsStatus] = useState([]);
  const [isHoveringStatus, setIsHoveringStatus] = useState(false);

  const [filterSource, setFilterSource] = useState([]);
  const [selectedOptionsSource, setSelectedOptionsSource] = useState([]);
  const [isHoveringSource, setIsHoveringSource] = useState(false);

  const [filterCompany, setFilterCompany] = useState([]);
  const [selectedOptionsCompany, setSelectedOptionsCompany] = useState([]);
  const [isHoveringCompany, setIsHoveringCompany] = useState(false);

  const [filterUser, setFilterUser] = useState([]);
  const [selectedOptionsUser, setSelectedOptionsUser] = useState([]);
  const [isHoveringUser, setIsHoveringUser] = useState(false);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [talkDateFrom, setTalkDateFrom] = useState("");
  const [talkDateTo, setTalkDateTo] = useState("");
  const [statusDateFrom, setStatusDateFrom] = useState("");
  const [statusDateTo, setStatusDateTo] = useState("");

  /* ══════════ FILTER OPTIONS (loaded once) ══════════ */
  const [sources, setSources] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersFull, setUsersFull] = useState([]);

  /* ══════════ UI STATE (modals, inline edit, etc.) ══════════ */
  const [showConf, setShowConf] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [expandId, setExpandId] = useState(0);

  const [editModeName, setEditModeName] = useState(false);
  const [editName, setEditName] = useState("");
  const [editNameId, setEditNameId] = useState("");

  const [editModePhone, setEditModePhone] = useState(false);
  const [editPhone, setEditPhone] = useState("");
  const [editPhoneId, setEditPhoneId] = useState("");

  const [editModeMail, setEditModeMail] = useState(false);
  const [editMail, setEditMail] = useState("");
  const [editMailId, setEditMailId] = useState("");

  const [editModeNote, setEditModeNote] = useState(false);
  const [editNote, setEditNote] = useState("");
  const [editNoteId, setEditNoteId] = useState("");

  const [showNote, setShowNote] = useState(false);
  const [showNoteId, setShowNoteId] = useState(false);
  const [showNoteB, setShowNoteB] = useState(false);
  const [showClientNote, setShowClientNote] = useState(false);
  const [showClientNoteId, setShowClientNoteId] = useState(false);
  const [noteMode, setNoteMode] = useState("note");
  const [leadDetail, setLeadDetail] = useState(null);
  const [showLeadDetail, setShowLeadDetail] = useState(false);

  const [showAdditionalLead, setShowAdditionalLead] = useState(false);
  const [showAdditionalLeadId, setShowAdditionalLeadId] = useState("");

  const [showAddContact, setShowAddContact] = useState(false);
  const [addContactLeadId, setAddContactLeadId] = useState("");

  const [showSendReport, setShowSendReport] = useState(false);
  const [showSendReportId, setShowSendReportId] = useState("");

  const [con, setCon] = useState("");
  const [checkLead, setCheckLead] = useState([]);
  const [showCheckCon, setShowCheckCon] = useState(false);

  const [chooseLeads, setChooseLeads] = useState([]);
  const [chooseLeadsFlag, setChooseLeadsFlag] = useState(false);

  /* ── Claim lead (Pobierz lead) ── */
  const [availableCount, setAvailableCount] = useState(0);
  const [claimedLead, setClaimedLead] = useState(null);
  const [showClaimedLead, setShowClaimedLead] = useState(false);

  /* ══════════════════════════════════════════════════════════ */
  /*  FETCH
  /* ══════════════════════════════════════════════════════════ */

  const fetchFilterData = async () => {
    try {
      const res = await fetch(`${API}/getDbFilterData`, {
        method: "POST",
        headers: hdrs,
        body: "{}",
      });
      const d = await res.json();
      setSources(d.sources || []);
      setCompanies(d.companies || []);
      setStatuses(d.statuses || []);
      setUsers(d.users || []);
      setUsersFull(d.usersFull || []);
    } catch (err) {
      console.error("fetchFilterData:", err);
    }
  };

  const fetchLeads = useCallback(
    async (bool, overrides = {}) => {
      if (bool) {
        setLoading(true);
      }

      try {
        const body = {
          page: overrides.page ?? page,
          limit: overrides.limit ?? limit,
          search: overrides.search ?? search,
          sources: overrides.sources ?? filterSource,
          companies: [props.option],
          statuses: overrides.statuses ?? filterStatus,
          sellers: overrides.sellers ?? filterUser,
          dateFrom: overrides.dateFrom ?? dateFrom,
          dateTo: overrides.dateTo ?? dateTo,
          talkDateFrom: overrides.talkDateFrom ?? talkDateFrom,
          talkDateTo: overrides.talkDateTo ?? talkDateTo,
          statusDateFrom: overrides.statusDateFrom ?? statusDateFrom,
          statusDateTo: overrides.statusDateTo ?? statusDateTo,
          sort: overrides.sort ?? sort,
          sortDir: overrides.sortDir ?? sortDir,
          sort2: overrides.sort2 ?? sort2,
          sortDir2: overrides.sortDir2 ?? sortDir2,
          user: props.user.id,
          role: props.user.role,
          companyFixed: props.option || "",
          subCompany: overrides.subCompany ?? filterCompany,
        };
        const res = await fetch(`${API}/getLeadsDbPaginated`, {
          method: "POST",
          headers: hdrs,
          body: JSON.stringify(body),
        });
        const d = await res.json();
        setLeads(d.data || []);
        setClicks(d.clicks || []);
        setTotal(d.total || 0);
        setTotalPages(d.totalPages || 0);
      } catch (err) {
        console.error("fetchLeads:", err);
      }
      setLoading(false);
    },
    [
      page,
      limit,
      search,
      filterSource,
      filterCompany,
      filterStatus,
      filterUser,
      dateFrom,
      dateTo,
      talkDateFrom,
      talkDateTo,
      statusDateFrom,
      statusDateTo,
      sort,
      sortDir,
      sort2,
      sortDir2,
      props.user.id,
      props.user.role,
      props.option,
    ]
  );

  /* ── init ── */
  useEffect(() => {
    (async () => {
      await Promise.all([fetchFilterData(), fetchLeads(true)]);
      setInitLoading(false);
    })();
  }, []);

  useEffect(() => {
    return attachCopyLogger(props.user);
  }, []);

  /* ── auto-refetch on page / limit / sort ── */
  useEffect(() => {
    if (initLoading) return;
    fetchLeads(true);
  }, [page, limit, sort, sortDir, sort2, sortDir2]);

  /* ── getData for after-action refresh ── */
  const getData = () => fetchLeads(true);
  const getDataRefresh = () => fetchLeads(false);

  /* ── Claim lead (Pobierz lead) ── */
  const fetchAvailableCount = async () => {
    try {
      const res = await fetch(`${API}/getAvailableLeadsCount`, {
        method: "POST",
        headers: hdrs,
        body: JSON.stringify({ company: props.option }),
      });
      const d = await res.json();
      setAvailableCount(d.count || 0);
    } catch (err) {
      console.error("fetchAvailableCount:", err);
    }
  };

  const handleClaimLead = async () => {
    try {
      const res = await fetch(`${API}/claimLead`, {
        method: "POST",
        headers: hdrs,
        body: JSON.stringify({ company: props.option, userId: props.user.id }),
      });
      const d = await res.json();
      if (d.ok && d.lead) {
        setClaimedLead(d.lead);
        setShowClaimedLead(true);
        fetchAvailableCount();
      } else {
        MySwal.fire({
          icon: "info",
          title: "Brak leadów",
          text: d.message || "Brak dostępnych leadów do pobrania",
        });
      }
    } catch (err) {
      console.error("claimLead:", err);
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Nie udało się pobrać leada",
      });
    }
  };

  const closeClaimedLead = () => {
    const statusModel = {};
    statuses.forEach((s) => {
      statusModel[s.name] = s.name;
    });

    MySwal.fire({
      title: "Wynik kontaktu",
      text: "Czy klient odebrał telefon?",
      showCancelButton: true,
      confirmButtonText: "✅ Odebrał",
      cancelButtonText: "❌ Nie odebrał",
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonColor: "#16a34a",
      cancelButtonColor: "#dc2626",
    }).then((result) => {
      if (result.isConfirmed) {
        // Odebrał → wybierz status
        MySwal.fire({
          title: "Wybierz status",
          input: "select",
          inputOptions: statusModel,
          inputPlaceholder: "Wybierz status...",
          showCancelButton: true,
          cancelButtonText: "Pozostaw ten sam status",
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: "Zapisz",
          inputValidator: (v) => (!v ? "Musisz wybrać status" : undefined),
        }).then(async (statusResult) => {
          if (claimedLead) {
            await fetch(`${API}/addLogPhone`, {
              method: "POST",
              headers: hdrs,
              body: JSON.stringify({
                type: "on",
                leadId: claimedLead.id,
                user: props.user.name,
                userId: props.user.id,
                userName: props.user.name,
              }),
            }).catch(() => {});

            if (statusResult.isConfirmed) {
              await fetch(`${API}/editLead`, {
                method: "POST",
                headers: hdrs,
                body: JSON.stringify({
                  id: claimedLead.id,
                  field: "status",
                  value: statusResult.value,
                  userId: props.user.id,
                  userName: props.user.name,
                }),
              }).catch(() => {});
              MySwal.fire({
                icon: "success",
                title: "Zapisano",
                text: `Status: ${statusResult.value}`,
              });
            } else {
              MySwal.fire({
                icon: "success",
                title: "Zapisano",
                text: "Odebrał — status bez zmian",
              });
            }
          }
          setShowClaimedLead(false);
          setClaimedLead(null);
          fetchAvailableCount();
          fetchLeads(false);
        });
      } else {
        // Nie odebrał → logPhone off, zostaje nowy, zamykamy
        (async () => {
          if (claimedLead) {
            await fetch(`${API}/addLogPhone`, {
              method: "POST",
              headers: hdrs,
              body: JSON.stringify({
                type: "off",
                leadId: claimedLead.id,
                user: props.user.name,
                userId: props.user.id,
                userName: props.user.name,
              }),
            }).catch(() => {});
          }
          setShowClaimedLead(false);
          setClaimedLead(null);
          fetchAvailableCount();
          fetchLeads(false);
        })();
      }
    });
  };

  // Fetch count on init and periodically
  useEffect(() => {
    if (!initLoading) fetchAvailableCount();
  }, [initLoading]);

  /* ══════════════════════════════════════════════════════════ */
  /*  FILTER / SEARCH HANDLERS
  /* ══════════════════════════════════════════════════════════ */

  const debouncedSearch = useDebounce((val) => {
    setSearch(val);
    setPage(1);
    fetchLeads(true, { search: val, page: 1 });
  }, 400);

  const handleSearchInput = (e) => {
    setSearchInput(e.target.value);
    debouncedSearch(e.target.value);
  };

  const applyFilter = (overrides) => {
    setPage(1);
    fetchLeads(true, { ...overrides, page: 1 });
  };

  const handleStatusChange = (val) => {
    setFilterStatus(val);
    applyFilter({ statuses: val });
  };
  const handleSourceChange = (val) => {
    setFilterSource(val);
    applyFilter({ sources: val });
  };
  const handleCompanyChange = (val) => {
    setFilterCompany(val);
    if (props.option === "SPRZEDAZ") {
      applyFilter({ subCompany: val });
    }
  };
  const handleUserChange = (val) => {
    setFilterUser(val);
    applyFilter({ sellers: val });
  };

  const applyDateRange = (from, to, fieldFrom, fieldTo) => {
    if (!from || !to) return;
    if (new Date(from) > new Date(to)) {
      MySwal.fire({
        icon: "error",
        title: "Błąd dat",
        text: '"Od" nie może być większe niż "Do"',
      });
      return;
    }
    applyFilter({ [fieldFrom]: from, [fieldTo]: to });
  };

  const clearFilters = () => {
    setSearchInput("");
    setSearch("");
    setFilterStatus([]);
    setSelectedOptionsStatus([]);
    setFilterSource([]);
    setSelectedOptionsSource([]);
    setFilterCompany([]);
    setSelectedOptionsCompany([]);
    setFilterUser([]);
    setSelectedOptionsUser([]);
    setDateFrom("");
    setDateTo("");
    setTalkDateFrom("");
    setTalkDateTo("");
    setStatusDateFrom("");
    setStatusDateTo("");
    setSort("statusPoz");
    setSortDir("ASC");
    setSort2("date");
    setSortDir2("DESC");
    setPage(1);
    fetchLeads(true, {
      search: "",
      sources: [],
      companies: [],
      statuses: [],
      sellers: [],
      dateFrom: "",
      dateTo: "",
      talkDateFrom: "",
      talkDateTo: "",
      statusDateFrom: "",
      statusDateTo: "",
      sort: "statusPoz",
      sortDir: "ASC",
      sort2: "date",
      sortDir2: "DESC",
      page: 1,
    });
  };

  /* ── sort select (compatibility with old UI style) ── */
  const handleSortSelectChange = (e) => {
    const v = e.target.value;
    if (v === "dateAsc") {
      setSort("date");
      setSortDir("ASC");
      setSort2("statusPoz");
      setSortDir2("ASC");
    } else if (v === "dateDesc") {
      setSort("statusPoz");
      setSortDir("ASC");
      setSort2("date");
      setSortDir2("DESC");
    }
  };

  const sortSelectValue =
    sort === "date" && sortDir === "ASC" ? "dateAsc" : "dateDesc";

  /* ── hovering ── */
  const closeAllHovering = (e) => {
    const id = e.target?.id;
    if (id !== "status") setIsHoveringStatus(false);
    if (id !== "source") setIsHoveringSource(false);
    if (id !== "user") setIsHoveringUser(false);
    if (id !== "company") setIsHoveringCompany(false);
  };

  /* ── option builders ── */
  const toOptions = (arr) => [
    { label: "Wszystkie", value: "all" },
    ...arr.map((el) => ({ label: el.name, value: el.name })),
  ];
  const getUserOptions = () => {
    const opts = [{ label: "Wszystkie", value: "all" }];
    usersFull.forEach((u) => opts.push({ label: u.name, value: u.id }));
    return opts;
  };

  /* ── page numbers ── */
  const pageNumbers = () => {
    const pages = [];
    const s = Math.max(1, page - 2);
    const e = Math.min(totalPages, page + 2);
    if (s > 1) pages.push(1);
    if (s > 2) pages.push("...");
    for (let i = s; i <= e; i++) pages.push(i);
    if (e < totalPages - 1) pages.push("...");
    if (e < totalPages) pages.push(totalPages);
    return pages;
  };

  /* ══════════════════════════════════════════════════════════ */
  /*  INLINE EDIT helpers (kept from original)
  /* ══════════════════════════════════════════════════════════ */

  const resetEditModes = () => {
    setEditModeName(false);
    setEditModePhone(false);
    setEditModeMail(false);
    setEditModeNote(false);
    setEditNameId("");
    setEditName("");
    setEditPhoneId("");
    setEditPhone("");
    setEditMailId("");
    setEditMail("");
    setEditNoteId("");
    setEditNote("");
  };

  const fetchEditLead = async (id, field, value) => {
    await fetch(`${API}/editLead`, {
      method: "POST",
      headers: hdrs,
      body: JSON.stringify({
        id,
        field,
        value,
        userId: props.user.id,
        userName: props.user.name,
      }),
    }).catch(() => {});
    getDataRefresh();
  };

  const editLeadField = (e) => {
    const id = e.currentTarget.value;
    const field = e.currentTarget.id;
    let val = "";
    if (field === "name") val = editName;
    else if (field === "phone") val = editPhone;
    else if (field === "mail") val = editMail;
    else if (field === "statusNote") val = editNote;
    fetchEditLead(id, field, val);
    resetEditModes();
  };

  const handleEditModeName = (e) => {
    resetEditModes();
    setEditModeName(true);
    setEditNameId(e.currentTarget.value);
    const lead = leads.find((el) => +el.id === +e.currentTarget.value);
    setEditName(lead?.name || "");
  };
  const handleEditModePhone = (e) => {
    resetEditModes();
    setEditModePhone(true);
    setEditPhoneId(e.currentTarget.value);
    const lead = leads.find((el) => +el.id === +e.currentTarget.value);
    setEditPhone(lead?.phone || "");
  };
  const handleEditModeMail = (e) => {
    resetEditModes();
    setEditModeMail(true);
    setEditMailId(e.currentTarget.value);
    const lead = leads.find((el) => +el.id === +e.currentTarget.value);
    setEditMail(lead?.mail || "");
  };
  const handleEditModeNote = (e) => {
    resetEditModes();
    setEditModeNote(true);
    setEditNoteId(e.currentTarget.value);
    const lead = leads.find((el) => +el.id === +e.currentTarget.value);
    setEditNote(lead?.statusNote || "");
  };

  /* ══════════════════════════════════════════════════════════ */
  /*  ACTION handlers (kept from original)
  /* ══════════════════════════════════════════════════════════ */

  const showLeadDetailBox = (e) => {
    e.preventDefault();
    const id = e.currentTarget.attributes.value.value;
    setLeadDetail(leads.find((l) => +l.id === +id));
    setShowLeadDetail(true);
  };
  const closeLeadDetail = () => {
    console.log("close");
    setShowLeadDetail(false);
    setShowClaimedLead(false);
    getDataRefresh();
  };

  const showNoteSourceBox = (e) => {
    e.preventDefault();
    const id = e.currentTarget.attributes.value.value;
    setLeadDetail(leads.find((l) => +l.id === +id));
    setNoteMode("source");
    setShowNoteB(true);
  };

  const handleShowNote = (e) => {
    const id = e.currentTarget.value;
    setShowNoteId(id);
    setShowNote(+id === +showNoteId ? !showNote : true);
  };

  const handleShowClientNote = (e) => {
    const id = e.currentTarget.value;
    setShowClientNoteId(id);
    setShowClientNote(+id === +showClientNoteId ? !showClientNote : true);
  };

  const expandLead = (e) => {
    e.preventDefault();
    const id = e.currentTarget.attributes.value.value;
    setExpandId(+expandId === +id ? 0 : id);
  };

  const editLeadStatus = (e) => {
    const id = e.currentTarget.value;
    const field = e.currentTarget.id;
    const model = {};
    statuses.forEach((el) => {
      model[el.name] = el.name;
    });
    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: (v) =>
        new Promise((res) => res(v ? undefined : "musisz wybrać wartość")),
    }).then((result) => {
      if (result.isConfirmed) {
        fetchEditLead(id, field, result.value);
        if (
          [
            "Zainteresowany TCHF",
            "Zainteresowany SKD",
            "Zainteresowany WIBOR",
          ].includes(result.value)
        ) {
          setShowAdditionalLead(true);
          setShowAdditionalLeadId(id);
        }
      }
    });
  };

  const editLeadSeller = (e) => {
    const id = e.currentTarget.value;
    const field = e.currentTarget.id;
    const company = e.currentTarget.attributes.fieldValue.value;
    const model = {};
    users
      .filter((u) => u.name !== "Rozdzielacz")
      .forEach((u) => {
        model[u.id] = u.name;
      });
    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: (v) =>
        new Promise((res) => res(v ? undefined : "musisz wybrać wartość")),
    }).then((result) => {
      if (result.isConfirmed) fetchEditLead(id, field, result.value);
    });
  };

  const editLeadDate = (e) => {
    setAddContactLeadId(e.currentTarget.value);
    setShowAddContact(true);
  };
  const closeAddContact = () => {
    setShowAddContact(false);
    getDataRefresh();
  };

  const closeAddtionalLead = () => {
    setShowAdditionalLeadId("");
    setShowAdditionalLead(false);
    getDataRefresh();
  };

  const closeCheckCon = () => {
    setShowCheckCon(false);
    setCon("");
    setCheckLead([]);
    getDataRefresh();
  };

  const addLogPhone = async (type, leadId) => {
    await fetch(`${API}/addLogPhone`, {
      method: "POST",
      headers: hdrs,
      body: JSON.stringify({
        type,
        leadId,
        user: props.user.name,
        userId: props.user.id,
        userName: props.user.name,
      }),
    }).catch(() => {});
    MySwal.fire({ icon: "success", title: "Dodano", text: "kontakt" });
    getDataRefresh();
  };

  const sendExternal = async (lead, target) => {
    const secret = "Ftp@)2%jsj@*";
    try {
      const v = JSON.parse(lead.validation);
      if (!v.bank || !v.ammount || !v.creditDate || !v.region)
        throw new Error("brak");
      const body = {
        name: lead.name,
        phone: lead.phone,
        mail: lead.mail,
        creditAgreement: v.bank,
        creditAmmount: v.ammount,
        creditDate: v.creditDate,
        creditCurrency: "PLN",
        leadArea: v.region,
        leadExpectations: "Cena",
        ...(target === "PCHF" ? { noContact: "false" } : {}),
      };
      const url =
        target === "PCHF"
          ? "https://porownywarkachfapi.ftpeople.pl/insert_lead_basic"
          : "https://api.twojeskd.pl/insert_lead_basic";
      await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: secret },
        body: JSON.stringify(body),
      });
      MySwal.fire({ icon: "success", title: "Wysłano", text: `do ${target}` });
    } catch {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "dane walidacyjne klienta",
      });
    }
  };

  const sendLeadSMSMAIL_after = (e) => {
    const id = e.currentTarget.value;
    const lead = leads.find((l) => +l.id === +id);
    const model = {
      TCHF: "Twoje CHF",
      AWIB: "Anulujemy WIBOR",
      ODSKD: "Odzyskaj SKD",
    };
    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: (v) =>
        new Promise((res) => res(v ? undefined : "musisz wybrać wartość")),
    }).then((result) => {
      if (result.isConfirmed && lead) {
        fetch(`${API}/sendMail`, {
          method: "POST",
          headers: hdrs,
          body: JSON.stringify({ mail: lead.mail, company: result.value }),
        }).catch(() => {});
        fetch(`${API}/sendSms`, {
          method: "POST",
          headers: hdrs,
          body: JSON.stringify({ phone: lead.phone, company: result.value }),
        }).catch(() => {});
      }
    });
  };

  const sendLeadToSendTemp = async (e) => {
    await fetch(`${API}/sendToSendTemp`, {
      method: "POST",
      headers: hdrs,
      body: JSON.stringify({ id: e.target.value }),
    }).catch(() => {});
    MySwal.fire({ icon: "success", title: "Przekazano", text: "do wysyłki" });
    getDataRefresh();
  };

  /* ── checkbox group actions ── */
  const handleChooseToggle = (e) => {
    const id = e.target.value;
    let arr;
    if (chooseLeads.includes(id)) {
      arr = chooseLeads.filter((x) => x !== id);
    } else {
      arr = [...chooseLeads, id];
    }
    setChooseLeads(arr);
    setChooseLeadsFlag(arr.length > 0);
  };

  const groupChangeStatus = () => {
    const model = {};
    statuses.forEach((el) => {
      model[el.name] = el.name;
    });
    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: (v) =>
        new Promise((res) => res(v ? undefined : "musisz wybrać wartość")),
    }).then(async (result) => {
      if (result.isConfirmed) {
        await fetch(`${API}/editLeadStatusGroup`, {
          method: "POST",
          headers: hdrs,
          body: JSON.stringify({
            leads: JSON.stringify(chooseLeads),
            status: result.value,
            userId: props.user.id,
            userName: props.user.name,
          }),
        }).catch(() => {});
        setChooseLeads([]);
        setChooseLeadsFlag(false);
        getDataRefresh();
      }
    });
  };

  const groupSendToShip = async () => {
    await fetch(`${API}/editLeadSendGroup`, {
      method: "POST",
      headers: hdrs,
      body: JSON.stringify({ leads: JSON.stringify(chooseLeads) }),
    }).catch(() => {});
    setChooseLeads([]);
    setChooseLeadsFlag(false);
    getDataRefresh();
  };

  /* ── excel export (current page) ── */
  const exportToExcel = () => {
    const header = [
      "ID",
      "Imię i nazwisko",
      "Numer telefonu",
      "Adres e-mail",
      "Status",
      "Źródło",
      "Informacje w trakcie rozmowy",
      "Data pozyskania",
      "Notatka",
      "Handlowiec",
      "Dział",
      "LINK źródło",
    ];
    const body = leads.map((el) => [
      el.id,
      el.name,
      el.phone,
      el.mail,
      el.status,
      el.source,
      el.sourceNote,
      el.date,
      el.statusNote,
      el.sellerN || "",
      el.company,
      el.sourceLink || "",
    ]);
    downloadExcel({
      fileName: "leads_report_" + new Date().toISOString().slice(0, 10),
      sheet: "data",
      tablePayload: { header, body },
    });
  };

  /* ── click stats helper ── */
  const getClicks = (leadId) => {
    const c = clicks.find((el) => +el.leadId === +leadId);
    return { on: c?.phoneOn || 0, off: c?.phoneOff || 0 };
  };

  /* ── status color ── */
  const statusColor = (statusName) => {
    const s = statuses.find((el) => el.name === statusName);
    return s?.color || "";
  };

  /* ── format date ── */
  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const dd = String(dt.getDate()).padStart(2, "0");
    return `${dt.getFullYear()}-${mm}-${dd}`;
  };

  /* ══════════════════════════════════════════════════════════ */
  /*  RENDER
  /* ══════════════════════════════════════════════════════════ */

  if (initLoading) return <Loading />;

  return (
    <div className="db-wrapper" onClick={closeAllHovering}>
      {/* ── MODALS ── */}
      {showAdditionalLead && (
        <AdditionalLead
          mode="add"
          lead={leads.find((e) => +e.id === +showAdditionalLeadId)}
          close={closeAddtionalLead}
        />
      )}
      {showSendReport && (
        <LeadSendDetail
          id={showSendReportId}
          close={() => {
            setShowSendReportId("");
            setShowSendReport(false);
          }}
        />
      )}

      {showAddContact && (
        <AddContact
          mode="list"
          user={props.user}
          leadId={addContactLeadId}
          close={closeAddContact}
        />
      )}
      {showNoteB && (
        <ShowNote
          close={() => setShowNoteB(false)}
          lead={leadDetail}
          mode={noteMode}
          option={props.option}
        />
      )}

      {showLeadDetail && leadDetail && (
        <div
          className="ld-modal-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) closeLeadDetail();
          }}
        >
          <div className="ld-modal">
            <LeadDetail
              close={closeLeadDetail}
              lead={leadDetail}
              seller={
                users.filter((e) => +e.id === +leadDetail.seller)[0]?.name ?? ""
              }
              user={props.user}
              option={props.option}
            />
          </div>
        </div>
      )}

      {/* ── CLAIMED LEAD MODAL (Pobierz lead) ── */}
      {showClaimedLead && claimedLead && (
        <div className="ld-modal-overlay">
          <div className="ld-modal">
            <div className="cl-banner">
              <span className="cl-banner-icon">📞</span>
              <span>
                Pamiętaj o potwierdzeniu obróbki kontaktu poprzez wybranie opcji{" "}
                <strong>Obsługa kontaktu</strong>.
              </span>
            </div>
            <LeadDetail
              close={closeLeadDetail}
              lead={claimedLead}
              user={props.user}
              option={props.option}
            />
          </div>
        </div>
      )}

      {/* ── FLOATING GROUP ACTIONS ── */}
      {chooseLeadsFlag && (
        <>
          <div
            className="db-float-action db-float-action--orange"
            style={{ top: "25vh" }}
            onClick={groupChangeStatus}
          >
            <span>ZMIEŃ STATUS</span>
          </div>
          <div
            className="db-float-action db-float-action--green"
            style={{ top: "35vh" }}
            onClick={groupSendToShip}
          >
            <span>PRZEKAŻ DO WYSYŁKI</span>
          </div>
        </>
      )}

      {/* ── TOOLBAR ── */}
      <div className="lq-toolbar">
        <div className="lq-toolbar-left">
          <button className="lq-btn lq-btn--success" onClick={getData}>
            Odśwież
          </button>
          {false && (
            <button className="lq-btn lq-btn--dark" onClick={exportToExcel}>
              Eksport
            </button>
          )}
          {!["SPRZEDAZ", "ALL"].includes(props.option) ? (
            <button
              className="lq-btn lq-btn--primary cl-claim-btn"
              onClick={handleClaimLead}
              disabled={availableCount === 0}
            >
              📞 Pobierz lead
              <span
                className={`cl-count-badge ${
                  availableCount === 0 ? "cl-count-badge--empty" : ""
                }`}
              >
                {availableCount}
              </span>
            </button>
          ) : (
            ""
          )}

          <div className="db-search-field">
            <label className="db-field-label">Szukaj</label>
            <input
              type="text"
              className="db-input"
              value={searchInput}
              onChange={handleSearchInput}
              placeholder="nazwa, tel., mail..."
            />
          </div>
        </div>
        <div className="lq-toolbar-left">
          <button
            className={`lq-btn ${
              showFilters ? "lq-btn--primary" : "lq-btn--muted"
            }`}
            onClick={() => setShowFilters(!showFilters)}
          >
            {showFilters ? "Zwiń filtry" : "Filtry"}
          </button>
          <span className="lq-count">
            {total.toLocaleString("pl-PL")} leadów
          </span>
        </div>
      </div>

      {showConf && (
        <Conf
          close={() => setShowConf(false)}
          querySource=""
          setQuerySource={() => {}}
          queryStatus=""
          setQueryStatus={() => {}}
          getData={getData}
        />
      )}

      {/* ── FILTERS ── */}
      {showFilters && (
        <div className="db-filters">
          {/* Row 1: Select filters */}
          <div className="db-filters-selects">
            <div className="db-filter-group">
              <label className="db-field-label">Status</label>
              <MultiSelect
                options={toOptions(statuses)}
                value={filterStatus}
                onChange={handleStatusChange}
                selectedOptions={selectedOptionsStatus}
                setSelectedOptions={setSelectedOptionsStatus}
                isHovering={isHoveringStatus}
                setIsHovering={setIsHoveringStatus}
                id="status"
                closeAllHovering={closeAllHovering}
              />
            </div>

            {isAdmin && (
              <>
                <div className="db-filter-group">
                  <label className="db-field-label">Źródło</label>
                  <MultiSelect
                    options={toOptions(sources)}
                    value={filterSource}
                    onChange={handleSourceChange}
                    selectedOptions={selectedOptionsSource}
                    setSelectedOptions={setSelectedOptionsSource}
                    isHovering={isHoveringSource}
                    setIsHovering={setIsHoveringSource}
                    id="source"
                    closeAllHovering={closeAllHovering}
                  />
                </div>
                {props.option === "ALL" && (
                  <div className="db-filter-group">
                    <label className="db-field-label">Dział</label>
                    <MultiSelect
                      options={toOptions(
                        props.option === "SPRZEDAZ"
                          ? companies.filter((el) => el.name !== "SPRZEDAZ")
                          : companies
                      )}
                      value={filterCompany}
                      onChange={handleCompanyChange}
                      selectedOptions={selectedOptionsCompany}
                      setSelectedOptions={setSelectedOptionsCompany}
                      isHovering={isHoveringCompany}
                      setIsHovering={setIsHoveringCompany}
                      id="company"
                      closeAllHovering={closeAllHovering}
                    />
                  </div>
                )}

                <div className="db-filter-group">
                  <label className="db-field-label">Handlowiec</label>
                  <MultiSelect
                    options={getUserOptions()}
                    value={filterUser}
                    onChange={handleUserChange}
                    selectedOptions={selectedOptionsUser}
                    setSelectedOptions={setSelectedOptionsUser}
                    isHovering={isHoveringUser}
                    setIsHovering={setIsHoveringUser}
                    id="user"
                    closeAllHovering={closeAllHovering}
                  />
                </div>
              </>
            )}
          </div>

          {/* Row 2: Date ranges */}
          <div className="db-filters-dates">
            <div className="db-filter-date-group">
              <label className="db-field-label">Data pozyskania</label>
              <div className="db-date-range">
                <div className="db-date-field">
                  <span className="db-date-label">od</span>
                  <input
                    type="date"
                    className="db-input"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                  />
                </div>
                <div className="db-date-field">
                  <span className="db-date-label">do</span>
                  <input
                    type="date"
                    className="db-input"
                    value={dateTo}
                    onChange={(e) => setDateTo(e.target.value)}
                  />
                </div>
                <button
                  className="lq-btn lq-btn--dark db-date-apply"
                  onClick={() =>
                    applyDateRange(dateFrom, dateTo, "dateFrom", "dateTo")
                  }
                >
                  OK
                </button>
              </div>
            </div>
            <div className="db-filter-date-group">
              <label className="db-field-label">Ost. kontakt</label>
              <div className="db-date-range">
                <div className="db-date-field">
                  <span className="db-date-label">od</span>
                  <input
                    type="date"
                    className="db-input"
                    value={talkDateFrom}
                    onChange={(e) => setTalkDateFrom(e.target.value)}
                  />
                </div>
                <div className="db-date-field">
                  <span className="db-date-label">do</span>
                  <input
                    type="date"
                    className="db-input"
                    value={talkDateTo}
                    onChange={(e) => setTalkDateTo(e.target.value)}
                  />
                </div>
                <button
                  className="lq-btn lq-btn--dark db-date-apply"
                  onClick={() =>
                    applyDateRange(
                      talkDateFrom,
                      talkDateTo,
                      "talkDateFrom",
                      "talkDateTo"
                    )
                  }
                >
                  OK
                </button>
              </div>
            </div>
            <div className="db-filter-date-group">
              <label className="db-field-label">Zmiana statusu</label>
              <div className="db-date-range">
                <div className="db-date-field">
                  <span className="db-date-label">od</span>
                  <input
                    type="date"
                    className="db-input"
                    value={statusDateFrom}
                    onChange={(e) => setStatusDateFrom(e.target.value)}
                  />
                </div>
                <div className="db-date-field">
                  <span className="db-date-label">do</span>
                  <input
                    type="date"
                    className="db-input"
                    value={statusDateTo}
                    onChange={(e) => setStatusDateTo(e.target.value)}
                  />
                </div>
                <button
                  className="lq-btn lq-btn--dark db-date-apply"
                  onClick={() =>
                    applyDateRange(
                      statusDateFrom,
                      statusDateTo,
                      "statusDateFrom",
                      "statusDateTo"
                    )
                  }
                >
                  OK
                </button>
              </div>
            </div>
          </div>

          <div className="db-filters-footer">
            <button className="lq-btn lq-btn--muted" onClick={clearFilters}>
              Wyczyść filtry
            </button>
            <select
              className="db-input db-select"
              style={{ width: "260px" }}
              value={sortSelectValue}
              onChange={handleSortSelectChange}
            >
              <option value="dateDesc">
                Priorytet statusu + od najnowszej
              </option>
              <option value="dateAsc">Data pozyskania - od najstarszej</option>
            </select>
          </div>
        </div>
      )}

      {/* ── PAGINATION TOP ── */}
      <div className="pg-bar">
        <div className="pg-bar-left">
          <label className="db-field-label">Na stronę</label>
          <select
            className="db-input db-select pg-limit-select"
            value={limit}
            onChange={(e) => {
              setLimit(+e.target.value);
              setPage(1);
            }}
          >
            {PAGE_SIZES.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          <span className="pg-info">
            {((page - 1) * limit + 1).toLocaleString("pl-PL")}–
            {Math.min(page * limit, total).toLocaleString("pl-PL")} z{" "}
            {total.toLocaleString("pl-PL")}
          </span>
        </div>
        <div className="pg-pages">
          <button
            className="pg-btn"
            disabled={page <= 1}
            onClick={() => setPage(page - 1)}
          >
            ‹
          </button>
          {pageNumbers().map((p, i) =>
            p === "..." ? (
              <span key={`e${i}`} className="pg-ellipsis">
                …
              </span>
            ) : (
              <button
                key={p}
                className={`pg-btn ${p === page ? "pg-btn--active" : ""}`}
                onClick={() => setPage(p)}
              >
                {p}
              </button>
            )
          )}
          <button
            className="pg-btn"
            disabled={page >= totalPages}
            onClick={() => setPage(page + 1)}
          >
            ›
          </button>
        </div>
      </div>

      {/* ── LEADS LIST ── */}
      {loading ? (
        <div className="pg-loading">Ładowanie...</div>
      ) : (
        <div className="db-leads-list">
          {leads.length === 0 && <div className="pg-loading">Brak wyników</div>}
          {leads.map((lead) => {
            const c = getClicks(lead.id);
            const isExpanded = +expandId === +lead.id;
            return (
              <div
                key={lead.id}
                className="db-lead-card"
                style={{ backgroundColor: statusColor(lead.status) }}
              >
                {/* ── ROW: main fields ── */}
                <div className="db-lead-row">
                  {/* checkbox */}
                  <div
                    className="db-lead-col"
                    style={{ width: "30px", flexShrink: 0 }}
                  >
                    <input
                      type="checkbox"
                      className="db-check"
                      value={lead.id}
                      checked={chooseLeads.includes(String(lead.id))}
                      onChange={handleChooseToggle}
                    />
                  </div>

                  {/* nazwa */}
                  <div className="db-lead-col db-lead-col--name">
                    <span className="db-lead-label">Nazwa</span>
                    {editModeName && +editNameId === +lead.id ? (
                      <div className="db-inline-edit">
                        <input
                          type="text"
                          className="db-input db-input--inline"
                          value={editName}
                          onChange={(e) => setEditName(e.target.value)}
                        />
                        <button
                          className="db-icon-btn"
                          id="name"
                          value={lead.id}
                          onClick={editLeadField}
                        >
                          <FontAwesomeIcon icon={faSave} />
                        </button>
                      </div>
                    ) : (
                      <span
                        className="db-lead-value"
                        data-log-field="name"
                        data-log-lead-id={lead.id}
                      >
                        {(lead.name || "").substring(0, 30)}
                      </span>
                    )}
                    <div className="db-lead-actions">
                      <button
                        className="db-icon-btn"
                        value={lead.id}
                        onClick={handleEditModeName}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        className="db-icon-btn"
                        value={lead.id}
                        onClick={showLeadDetailBox}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                      <button
                        className="db-icon-btn"
                        value={lead.id}
                        onClick={showNoteSourceBox}
                      >
                        <FontAwesomeIcon icon={faFile} />
                      </button>
                    </div>
                  </div>

                  {/* telefon */}
                  <div className="db-lead-col db-lead-col--phone">
                    <span className="db-lead-label">Telefon</span>
                    {editModePhone && +editPhoneId === +lead.id ? (
                      <div className="db-inline-edit">
                        <input
                          type="text"
                          className="db-input db-input--inline"
                          value={editPhone}
                          onChange={(e) => setEditPhone(e.target.value)}
                        />
                        <button
                          className="db-icon-btn"
                          id="phone"
                          value={lead.id}
                          onClick={editLeadField}
                        >
                          <FontAwesomeIcon icon={faSave} />
                        </button>
                      </div>
                    ) : (
                      <span
                        className="db-lead-value"
                        data-log-field="phone"
                        data-log-lead-id={lead.id}
                      >
                        {lead.phone}
                      </span>
                    )}
                    <div className="db-lead-actions">
                      <button
                        className="db-icon-btn"
                        value={lead.id}
                        onClick={handleEditModePhone}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </div>
                  </div>

                  {/* email */}
                  <div className="db-lead-col db-lead-col--mail">
                    <span className="db-lead-label">E-mail</span>
                    {editModeMail && +editMailId === +lead.id ? (
                      <div className="db-inline-edit">
                        <input
                          type="text"
                          className="db-input db-input--inline"
                          value={editMail}
                          onChange={(e) => setEditMail(e.target.value)}
                        />
                        <button
                          className="db-icon-btn"
                          id="mail"
                          value={lead.id}
                          onClick={editLeadField}
                        >
                          <FontAwesomeIcon icon={faSave} />
                        </button>
                      </div>
                    ) : (
                      <span
                        className="db-lead-value"
                        style={{ wordBreak: "break-all" }}
                        data-log-field="mail"
                        data-log-lead-id={lead.id}
                      >
                        {lead.mail}
                      </span>
                    )}
                    <div className="db-lead-actions">
                      <button
                        className="db-icon-btn"
                        value={lead.id}
                        onClick={handleEditModeMail}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </div>
                  </div>

                  {/* notatka */}
                  <div className="db-lead-col db-lead-col--note">
                    <span className="db-lead-label">Notatka</span>
                    {editModeNote && +editNoteId === +lead.id ? (
                      <div className="db-inline-edit">
                        <textarea
                          className="db-input db-input--inline"
                          style={{ minHeight: "40px" }}
                          value={editNote}
                          onChange={(e) => setEditNote(e.target.value)}
                        />
                        <button
                          className="db-icon-btn"
                          id="statusNote"
                          value={lead.id}
                          onClick={editLeadField}
                        >
                          <FontAwesomeIcon icon={faSave} />
                        </button>
                      </div>
                    ) : (
                      <span className="db-lead-value">
                        {showNote && +showNoteId === +lead.id
                          ? lead.statusNote
                          : (lead.statusNote || "").substring(0, 50) +
                            (lead.statusNote?.length > 50 ? "…" : "")}
                      </span>
                    )}
                    <div className="db-lead-actions">
                      <button
                        className="db-icon-btn"
                        value={lead.id}
                        onClick={handleShowNote}
                      >
                        <FontAwesomeIcon
                          icon={
                            showNote && +showNoteId === +lead.id
                              ? faEyeSlash
                              : faEye
                          }
                        />
                      </button>
                      <button
                        className="db-icon-btn"
                        value={lead.id}
                        onClick={handleEditModeNote}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </div>
                  </div>

                  {/* źródło */}
                  <div className="db-lead-col db-lead-col--source">
                    <span className="db-lead-label">Źródło</span>
                    <span className="db-lead-value">{lead.source}</span>
                  </div>

                  {/* status */}
                  <div className="db-lead-col db-lead-col--status">
                    <span className="db-lead-label">Status</span>
                    <span className="db-lead-value">{lead.status}</span>
                    <div className="db-lead-actions">
                      <button
                        className="db-icon-btn"
                        id="status"
                        value={lead.id}
                        onClick={editLeadStatus}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </div>
                  </div>

                  {/* rozwiń */}
                  <div
                    className="db-lead-col"
                    style={{ width: "50px", flexShrink: 0 }}
                  >
                    <button
                      className="lq-btn lq-btn--muted db-expand-btn"
                      value={lead.id}
                      onClick={expandLead}
                    >
                      {isExpanded ? "zwiń" : "rozwiń"}
                    </button>
                  </div>
                </div>

                {/* ── EXPANDED ROW ── */}
                {isExpanded && (
                  <div className="db-lead-expanded">
                    <div className="db-lead-expanded-row">
                      <div className="db-expand-field">
                        <span className="db-lead-label">Data pozyskania</span>
                        <span>{fmtDate(lead.date)}</span>
                      </div>
                      {isAdmin && (
                        <div className="db-expand-field">
                          <span className="db-lead-label">Handlowiec</span>
                          <span>{lead.sellerN || "nie przypisano"}</span>
                          <button
                            className="db-icon-btn"
                            id="seller"
                            value={lead.id}
                            fieldValue={lead.company}
                            onClick={editLeadSeller}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="db-lead-expanded-row">
                      {isAdmin && +lead.sendTemp !== 1 && (
                        <div className="db-expand-field">
                          <button
                            className="lq-btn lq-btn--dark"
                            style={{ backgroundColor: "green" }}
                            value={lead.id}
                            onClick={sendLeadToSendTemp}
                          >
                            DO WYSYŁKI
                          </button>
                        </div>
                      )}
                      {+lead.sendDone === 1 && (
                        <div className="db-expand-field">
                          <button
                            className="lq-btn lq-btn--dark"
                            style={{ backgroundColor: "blue" }}
                            value={lead.id}
                            onClick={(e) => {
                              setShowSendReport(true);
                              setShowSendReportId(e.target.value);
                            }}
                          >
                            SZCZEGÓŁY WYSYŁKI
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* ── PAGINATION BOTTOM ── */}
      {totalPages > 1 && (
        <div className="pg-bar pg-bar--bottom">
          <span className="pg-info">
            Strona {page} z {totalPages}
          </span>
          <div className="pg-pages">
            <button
              className="pg-btn"
              disabled={page <= 1}
              onClick={() => setPage(1)}
            >
              «
            </button>
            <button
              className="pg-btn"
              disabled={page <= 1}
              onClick={() => setPage(page - 1)}
            >
              ‹
            </button>
            <button
              className="pg-btn"
              disabled={page >= totalPages}
              onClick={() => setPage(page + 1)}
            >
              ›
            </button>
            <button
              className="pg-btn"
              disabled={page >= totalPages}
              onClick={() => setPage(totalPages)}
            >
              »
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Database;
